module.exports = __webpack_public_path__ + "static/media/IYPT.c180941d.png";